export const setEvSkuId = (evSkuIds, evFlag, skuId) => evFlag ? [...evSkuIds, skuId] : evSkuIds
